import { createContext, useContext } from 'react';

type NewNotificationsContextType = boolean | undefined;

export const NewNotificationsContext = createContext<NewNotificationsContextType>(undefined);

export const useNewNotificationsContext = () => {
  const context = useContext(NewNotificationsContext);

  return context;
};
export const NewNotificationsProvider = NewNotificationsContext.Provider;
